module.exports = __webpack_public_path__ + "static/media/TABLAS DE RETENCION DOCUMENTAL NOTARIA.c829bc21.pdf";